import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop1",
  "use": "icon-stop1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stop1\">\n<circle cx=\"8\" cy=\"8\" r=\"6\" fill=\"#5C677C\" />\n<rect x=\"4\" y=\"8.75\" width=\"1.5\" height=\"8\" rx=\"0.75\" transform=\"rotate(-90 4 8.75)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol